<template>
  <div class="menu-box flex flex-row items-center justify-center">
    <div class="menu-box__item">
      <ul>
        <li class="tab">
          <router-link class="t-l" to="home">网站首页</router-link>
        </li>
        <li class="tab">
          <div>公司介绍</div>
          <ul>
            <li>
              <router-link :to="{path:'details',query:{id:`10`}}">公司简介</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id:`9`}}">组织架构</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `11`}}">水质监测</router-link>
            </li>
            <li>
              <router-link :to="{path: 'honor'}">历届荣誉</router-link>
            </li>
          </ul>
        </li>
        <li class="tab">
          <div>网上营业厅</div>
          <ul>
            <li>
              <router-link :to="{path:'list',query:{type: `10`}}">办事指南</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `12`}}">收费标准</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `605`}}">微信缴费</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `14`}}">生活缴费</router-link>
            </li>
            <li>
              <router-link :to="{path:'list',query:{type: `15`}}">缴费地址</router-link>
            </li>
            <li>
              <a target="_blank" href="http://zls.jszls.com.cn/index/search/index.html">供水自助报装</a>
            </li>
          </ul>
        </li>
        <li class="tab">
          <div>水务资讯</div>
          <ul>
            <li>
              <router-link :to="{path:'list',query:{type: `1`}}">公司动态</router-link>
            </li>
            <li>
              <router-link :to="{path:'list',query:{type: `2`}}">行业资讯</router-link>
            </li>
            <li>
              <router-link :to="{path:'list',query:{type: `3`}}">用水常识</router-link>
            </li>
          </ul>
        </li>
        <li class="tab">
          <div>优化营商环境</div>
          <ul>
            <li>
              <router-link :to="{path:'list',query:{type: `16`}}">政策性文件</router-link>
            </li>
            <li>
              <router-link :to="{path:'list',query:{type: `17`}}">媒体宣传</router-link>
            </li>
            <li>
              <router-link :to="{path:'list',query:{type: `18`}}">公司要闻</router-link>
            </li>
          </ul>
        </li>
        <li class="tab">
          <div>智慧水务</div>
          <ul>
            <li>
              <router-link :to="{path:'details',query:{id: `15`}}">供水调度</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `16`}}">智慧生产</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `17`}}">智慧营抄</router-link>
            </li>
            <li>
              <router-link :to="{path:'details',query:{id: `18`}}">智能水表</router-link>
            </li>
          </ul>
        </li>
        <li class="tab">
          <router-link :to="{path:'list',query:{type: `11`}}">招投标公告</router-link>
        </li>
        <ul></ul>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-menu"
};
</script>

<style lang="scss" scoped>
.menu-box {
  &__item {
    ul {
      .tab{
        a{
          color: #fff;
          font-size: 15px;
          font: 14px/1.5 "normal arial", 微软雅黑;
          text-decoration: none;
          line-height: 54px;
          cursor: pointer;
        }
      }
      .tab:hover {
        background: url(../../../assets/navb.png)
          no-repeat;
        height: 54px;
      }
      li:hover {
        ul {
          display: block;
        }
      }
      li {
        ul {
          display: none;
          position: absolute;
          top: 54px;
          z-index: 5;
          li {
            background: hsla(0, 0%, 0%, 0.9);
            width: 110px;
            border-bottom: 1px solid #ccc;
          }
        }
        div,
        .t-l {
          color: #fff;
          font-size: 15px;
          font: 14px/1.5 "normal arial", 微软雅黑;
          text-decoration: none;
          line-height: 54px;
          cursor: pointer;
        }
        float: left;
        width: 133px;
        height: 54px;
        text-align: center;
        line-height: 54px;
        position: relative;
        list-style: none;
        display: list-item;
      }
      width: 100%;
    }
    width: 1200px;
    height: 100%;
  }
  width: 100%;
  height: 54px;
  background: #337ab7;
}
</style>



// WEBPACK FOOTER //
// src/components/front/menu/Menu.vue